import { Box } from '@material-ui/core';
import dialogWrapperStyles from 'pages/stories/styles/dialogWrapper';
import { FunctionComponent } from 'react';

interface TitleBarWrapperI {
  title: string;
  value: string;
}

const DialogueWrapper: FunctionComponent<TitleBarWrapperI> = ({
  title,
  value
}: TitleBarWrapperI) => {
  const classes = dialogWrapperStyles();

  return (
    <Box>
      <div className={classes.title}>{title}</div>
      <div className={classes.value}>{value}</div>
    </Box>
  );
};

export default DialogueWrapper;
